import React from "react";
import { useState, useMemo, useEffect } from "react";
import ListTable from "../utils/Table";
import Form from "../utils/Form";
import ViewChange from "../utils/ViewChange";
import { quick_promotion_create ,all_quick_promotion_list , quick_promotion_update , quick_promotion_delete} from '../../actions/promotion';
import { all_movie_list } from "../../actions/Movie/video";
import { all_series_list } from "../../actions/WebSeries/series";
// import { all_customer_list } from '../../actions/customer';
// import { all_distributor_list } from '../../actions/distributor';
// import {

// 	all_advertiser_list,
// } from "../../actions/Advertiser/advertiser";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation , useNavigate } from "react-router-dom";
import EnlargedView from "../utils/EnlargedView";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
export default function Promotion() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const user = useSelector((state) => state.layout.profile)

	const [open, setOpen] = useState(false);
	const [content, setContent] = useState();
	const handleOpen = () => setOpen(true);
	const location = useLocation();
	const [form, setForm] = useState((location?.state?.form && JSON.parse(location?.state?.form)) || {});
	const [view, setView] = useState(location?.state?.view || "view_all");
	const [isEdit, setIsEdit] = useState(false);
	useMemo(() => {
		if (isEdit) { setView("create_new") }
		else {
			setView("view_all")
			setForm({});
		}
	}, [isEdit]);
	const path = location?.pathname.split("/")[2]

	useEffect(() => {
		setView(path != "Promotion" ? "create_new" : "view_all");
		setForm((location?.state?.form && JSON.parse(location?.state?.form)) || { ...form, set_sequence: tableData?.tableBody?.length + 1 });
		setIsEdit(path == "EditPromotion");
	}, [location]);
	const tempTableData = {
		tableTitle: "Promote Movie", 
		deleteRecord: quick_promotion_delete,
		updateRecord: quick_promotion_update,
		onDeleteText: "Are you sure want to delete?",
		onUpdateText: "Are you Sure?",
		tableHead: [
			{
				id: "promotion_title",
				label: "Promotion Title",
				// isSpecial: true
			},
			{
				id:"video",
				label:"Video"
			},

			{
				id: "promotion_image_web",
				label: "Image",
				isImage: true
			},
			{
				id: "promotion_end_date",
				label: "Expired on",
			},

		 {
				id: "edit",
				label: "Update",
				
			}
		].filter(e => e),
		tableBody: [

		],
	}
	const [tableData, setTableData] = useState({ ...tempTableData });

	const [formStructure, setFormStructure] = useState([
		  {
			id: "1",
			type: "select",
			title: "Select Video",
			options: [],
			name: "video",
			required: true,
		  },
		{
			id: "2",
			type: "inputBox",
			size: "6",
			title: "Promotion Title",
			name: "promotion_title",
			required: true
		},
		{
			id: "3",
			type: "inputBox",
			variant: "date",
			title: "Start on",
			min: new Date().toISOString().split('T')[0],
			default:" ",
			name: "promotion_start_date",
			required: true
		},

		// {
		// 	id: "4",
		// 	type: "image",
		// 	title: "Promotion Image (App)",
		// 	name: "promotion_image",
		// 	subtitle: "(Resolution : 910px x 1280px) *",
		// 	subsubtitle: "Max File Size 1MB",
		// 	subsubsubtitle: "Support only JPG,PNG,JPEG",
		// },
		{
			id: "5",
			type: "image",
			subtitle: "(Resolution : 1920px x 900px) *",
			subsubtitle: "Max File Size 1MB",
			subsubsubtitle: "Support only JPG,PNG,JPEG",
			title: 'Promotion Image (Web)',
			name: "promotion_image_web",
			size: 3
		},
		{
			id: "6",
			type: "button",
			title: "Send",
		},
	]);


	
	useEffect(() => {
		if(user?.id){const data = new FormData()
		data.append('id', user?.id)
		dispatch(all_quick_promotion_list(data))
		dispatch(all_movie_list(data));}
	}, [user?.id])
	const movies = useSelector((state) => state.movies.movies);
	const promotion = useSelector((state) => state.promotion.promotion);
	useMemo(() => {

		if (promotion?.statuscode == 200) {
			const temp = tableData
			temp.tableBody = promotion?.data.map((ele) => ({
				...ele, 
				
				video : ele?.video?.video_name,
				// movie_ownership : ele?.video_type !== "Series" ? ele?.movie?.movie_ownership == "Distributor" ? <><p style={{color:"var(--themeFontColor)"}}>{ele?.movie?.movie_ownership}</p> <p style={{color:"var(--themeFontColor)"}}>({ele?.movie?.movie_distributor?.name})</p></> : <p style={{color:"var(--themeFontColor)"}}>{ele?.movie?.movie_ownership}</p> :
				// ele?.series?.series_ownership == "Distributor" ? <><p style={{color:"var(--themeFontColor)"}}>{ele?.series?.series_ownership}</p> <p style={{color:"var(--themeFontColor)"}}>({ele?.series?.series_distributor?.name})</p></> : <p style={{color:"var(--themeFontColor)"}}>{ele?.series?.series_ownership}</p> 
			}))
			//   temp.tableBody=notifications?.data

			setTableData({ ...temp })
		}
	}, [promotion])
	// useMemo(() => {
	// 	if (isEdit) {
	// 	  const temp = formStructure;
	// 	  temp[0]["type"] = "inputBox";
	// 	  temp[0]["disabled"] = true;
	// 	  setFormStructure([...temp]);
	// 	} else {
	// 	  const temp = formStructure;
	
	// 	  temp[0]["type"] = "select";
	// 	  temp[0]["disabled"] = false;
	// 	  setFormStructure([...temp]);
	// 	}
	//   }, [isEdit]);
	useMemo(() => {
		if (movies?.statuscode == 200) {
			const temp = formStructure;
		  temp[0]["options"] = movies?.data.map((ele) => ele.video_name);
		  setFormStructure([...temp]);
		} 
		
	  }, [movies]);

	const formTitle = isEdit ? "Edit Promotion" : "Create Promotion";

	const message = useSelector((state) => state.layout.message);
	const handleSubmit = (event) => {
		event.preventDefault();
		const data = new FormData();

		const temp_form = form;

		temp_form["tempvideo"] = form?.["video"];
		temp_form["video"] = movies?.data
		  .map(
			(option) => form?.["video"]?.includes(option?.video_name) && option?.id
		  )
		  .filter((e) => e)[0];
		
		  setForm({ ...temp_form });

		
		Object.keys(form).map((key) => data.append(key, form?.[key]));
		data.append("user", user?.id);
		formStructure.map((element) => {
			if (element.type == "image" && form?.[element.name] && typeof (form?.[element.name]) != "string") {
				const temp = form;
				temp["temp" + element.name] = form?.[element.name];
				temp[element.name] = URL.createObjectURL(form?.[element.name]);

				setForm({
					...temp,
				});
			}
		});
		if (isEdit) {
			dispatch(quick_promotion_update(data))
		}
		else {
			dispatch(quick_promotion_create(data))
		}


	};
	useMemo(() => {
		if (message?.statuscode == 200) {
			const temp = tableData;
			if (isEdit) {
				temp.tableBody.map(
					(value, index) =>
						value.id == form.id && (temp.tableBody[index] = { ...form })
				);

			} else {
				temp.tableBody[temp.tableBody.length] = {
					id: temp.tableBody.length,
					...form,
					edit: temp.tableBody.length,
				};

			}
			setTableData({ ...temp });
			setIsEdit(false);
			setForm({});
			setTimeout(() => {
				const data = new FormData()
				data.append('id', user?.id)
				dispatch(all_quick_promotion_list(data));
				navigate("/Promotion/Promotion/", { state: { view: "view_all" } })

				setView("view_all");
			}, 1000);
		}
		else {
			const temp = form
			
			setForm({ ...temp });
		}
	}, [message])

	return (
		<>
			<EnlargedView open={open} setOpen={setOpen} content={content} />
			{ <ViewChange
				setForm={setForm}
				setView={setView}
				setIsEdit={setIsEdit}
				view={view}
				isEdit={isEdit}
				create_new={"/Promotion/CreatePromotion"}
				view_all={"/Promotion/Promotion"}
				form={form}

			/>}

			{view == "create_new" && (
				<Form
					formStructure={formStructure}
					handleSubmit={handleSubmit}
					formTitle={formTitle}
					key={"Form"}
					setForm={setForm}
					form={form}
					tableData={tableData}
					setTableData={setTableData}
					isEdit={isEdit}
					setIsEdit={setIsEdit}
				/>
			)}
			{view == "view_all" && (
				<ListTable
					tableData={tableData}
					key={"ListTable"}
					setForm={setForm}
					setTableData={setTableData}
					setIsEdit={setIsEdit}
					create_new={"/Promotion/EditPromotion"}
				/>
			)}
		</>
	);
}
